export const videos = [
  // ================= 电影 =================
  {
    id: "movie-01",
    title: "暗夜追凶",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "犯罪"],
    director: "陈立",
    cast: ["张骁", "林晚", "赵启明"],
    rating: 8.6,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%2C%20a%20lone%20detective%20silhouette%20in%20a%20rain-soaked%20night%20city%20alley%2C%20neon%20reflections%2C%20dramatic%20low-key%20lighting%20with%20warm%20orange%20rim%20light%2C%20deep%20shadows%2C%20moody%20fog%2C%20minimal%20composition%20with%20space%20at%20top%2C%20editorial%20film%20key%20art&width=600&height=900&seq=md-mv-01&orientation=portrait",
    summary: "一桩尘封多年的旧案重新浮出水面，退休刑警在雨夜中追查真凶，却发现真相远比想象中更加残酷。",
    status: "蓝光1080P",
    hot: 9821,
    updatedAt: "2024-09-12",
    tags: ["高智商犯罪", "反转", "警匪"],
  },
  {
    id: "movie-02",
    title: "星际边境",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["科幻", "冒险"],
    director: "凯文·雷",
    cast: ["艾登·科尔", "索菲亚·里德"],
    rating: 8.2,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20sci-fi%20movie%20poster%2C%20a%20lone%20astronaut%20before%20a%20giant%20glowing%20planet%20horizon%2C%20deep%20space%20nebula%2C%20quiet%20dramatic%20lighting%20with%20amber%20accent%20glow%2C%20minimal%20composition%20with%20negative%20space%20at%20top%2C%20high%20detail%20editorial%20film%20key%20art&width=600&height=900&seq=md-mv-02&orientation=portrait",
    summary: "人类首次跨越星际边境寻找新家园，一支探险队却在未知星域遭遇了远超想象的危机。",
    status: "HD中字",
    hot: 8730,
    updatedAt: "2024-08-02",
    tags: ["太空", "末日", "视效大片"],
  },
  {
    id: "movie-03",
    title: "长安旧梦",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "剧情"],
    director: "苏文清",
    cast: ["顾清欢", "沈舟", "柳知遥"],
    rating: 8.8,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20ancient%20Chinese%20period%20drama%20poster%2C%20elegant%20figure%20in%20traditional%20Hanfu%20standing%20beneath%20lanterns%20in%20an%20old%20palace%20courtyard%2C%20warm%20amber%20lantern%20light%20against%20deep%20shadow%2C%20falling%20petals%2C%20minimal%20elegant%20composition%2C%20high%20detail%20film%20key%20art&width=600&height=900&seq=md-mv-03&orientation=portrait",
    summary: "盛世长安的一场旧梦，牵出一段被史书掩埋的往事，家国与情义之间，她必须做出抉择。",
    status: "蓝光1080P",
    hot: 9640,
    updatedAt: "2024-09-28",
    tags: ["古装", "家国情怀", "口碑佳作"],
  },
  {
    id: "movie-04",
    title: "极速之外",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["动作", "赛车"],
    director: "马克·道森",
    cast: ["卢卡斯·格雷", "伊娃·门罗"],
    rating: 7.9,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20action%20racing%20movie%20poster%2C%20a%20sports%20car%20speeding%20through%20a%20night%20city%20tunnel%20with%20motion%20blur%20light%20trails%2C%20dramatic%20low-key%20lighting%2C%20orange%20and%20steel%20tones%2C%20deep%20shadows%2C%20bold%20minimal%20composition%2C%20high%20detail%20film%20key%20art&width=600&height=900&seq=md-mv-04&orientation=portrait",
    summary: "地下赛车手为救回被卷入阴谋的兄长，被迫卷入一场以生命为赌注的极速竞赛。",
    status: "HD中字",
    hot: 7120,
    updatedAt: "2024-06-15",
    tags: ["飙车", "兄弟情", "爽片"],
  },
  {
    id: "movie-05",
    title: "雾都谜案",
    type: "movie",
    year: 2024,
    region: "英国",
    genres: ["悬疑", "惊悚"],
    director: "奥利弗·布莱克",
    cast: ["亨利·卡特", "艾米莉·肖"],
    rating: 8.4,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20British%20mystery%20thriller%20poster%2C%20a%20figures%20walking%20under%20gas%20lamps%20in%20a%20foggy%20Victorian%20London%20street%2C%20dense%20mist%2C%20warm%20lamp%20glow%20against%20cold%20shadows%2C%20moody%20low-key%20lighting%2C%20minimal%20composition%2C%20editorial%20film%20key%20art&width=600&height=900&seq=md-mv-05&orientation=portrait",
    summary: "浓雾笼罩的伦敦接连发生离奇命案，一位固执的探长循着蛛丝马迹，揭开一段被掩埋的家族秘密。",
    status: "HD中字",
    hot: 8320,
    updatedAt: "2024-09-05",
    tags: ["英伦", "推理", "犯罪"],
  },
  {
    id: "movie-06",
    title: "山海奇谭",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["奇幻", "动画"],
    director: "周牧野",
    cast: ["季冠霖", "边江"],
    rating: 9.0,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20Chinese%20mythology%20animated%20film%20poster%2C%20a%20young%20hero%20facing%20a%20giant%20mythical%20beast%20amid%20floating%20mountains%20and%20glowing%20clouds%2C%20warm%20amber%20light%20against%20deep%20ink%20shadows%2C%20epic%20yet%20minimal%20composition%2C%20high%20detail%20key%20art&width=600&height=900&seq=md-mv-06&orientation=portrait",
    summary: "少年为寻回被山海异兽夺走的故乡，踏上穿越上古神话世界的冒险旅程。",
    status: "蓝光1080P",
    hot: 10240,
    updatedAt: "2024-10-01",
    tags: ["国漫", "神话", "合家欢"],
  },
  {
    id: "movie-07",
    title: "深海回响",
    type: "movie",
    year: 2023,
    region: "韩国",
    genres: ["灾难", "剧情"],
    director: "朴俊浩",
    cast: ["李在勋", "金素妍"],
    rating: 8.1,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20disaster%20drama%20poster%2C%20a%20deep%20ocean%20research%20submarine%20diving%20into%20a%20vast%20dark%20trench%20with%20a%20single%20warm%20light%20beam%2C%20cold%20deep%20shadows%2C%20moody%20underwater%20atmosphere%2C%20minimal%20composition%20with%20space%20at%20top%2C%20film%20key%20art&width=600&height=900&seq=md-mv-07&orientation=portrait",
    summary: "深海勘探队遭遇海底地震被困万米海沟，绝境之中，人性的光与暗同时被点亮。",
    status: "HD中字",
    hot: 6890,
    updatedAt: "2024-05-20",
    tags: ["灾难", "深海", "催泪"],
  },
  {
    id: "movie-08",
    title: "时光信笺",
    type: "movie",
    year: 2024,
    region: "日本",
    genres: ["爱情", "奇幻"],
    director: "佐藤健一",
    cast: ["佐藤翔", "中村葵"],
    rating: 8.5,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20romantic%20fantasy%20movie%20poster%2C%20a%20young%20woman%20holding%20an%20old%20letter%20by%20a%20window%20at%20dusk%20with%20floating%20light%20particles%2C%20warm%20amber%20glow%20against%20deep%20muted%20shadows%2C%20soft%20melancholic%20mood%2C%20minimal%20elegant%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-mv-08&orientation=portrait",
    summary: "一封来自十年前的旧信，让两个在不同时空的人得以通信，也改写了两段人生。",
    status: "HD中字",
    hot: 8200,
    updatedAt: "2024-08-18",
    tags: ["催泪", "穿越时空", "纯爱"],
  },
  {
    id: "movie-09",
    title: "铁血防线",
    type: "movie",
    year: 2022,
    region: "中国大陆",
    genres: ["战争", "动作"],
    director: "李国强",
    cast: ["王铁军", "刘振华"],
    rating: 8.3,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20war%20action%20movie%20poster%2C%20a%20weary%20soldier%20standing%20before%20burning%20ruins%20at%20night%2C%20embers%20floating%20in%20the%20air%2C%20warm%20firelight%20against%20cold%20dark%20smoke%2C%20gritty%20high%20contrast%20lighting%2C%20minimal%20bold%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-mv-09&orientation=portrait",
    summary: "一场实力悬殊的阻击战，一支残破的连队，用血肉之躯守住了最后的防线。",
    status: "蓝光1080P",
    hot: 7560,
    updatedAt: "2024-04-10",
    tags: ["热血", "战争", "家国"],
  },
  {
    id: "movie-10",
    title: "城市边缘",
    type: "movie",
    year: 2024,
    region: "中国香港",
    genres: ["犯罪", "剧情"],
    director: "杜文杰",
    cast: ["陈子豪", "郑嘉欣"],
    rating: 8.7,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20crime%20drama%20poster%2C%20a%20man%20in%20a%20long%20coat%20standing%20in%20a%20narrow%20neon-lit%20Hong%20Kong%20street%20at%20night%2C%20wet%20pavement%20reflections%2C%20warm%20orange%20neon%20against%20deep%20shadows%2C%20moody%20minimal%20composition%2C%20editorial%20film%20key%20art&width=600&height=900&seq=md-mv-10&orientation=portrait",
    summary: "在城市的灰色边缘，一个小人物为了生存被卷入黑帮漩涡，最终不得不直面自己的良心。",
    status: "蓝光1080P",
    hot: 9010,
    updatedAt: "2024-09-20",
    tags: ["港片", "黑帮", "人性"],
  },
  {
    id: "movie-11",
    title: "无声证词",
    type: "movie",
    year: 2023,
    region: "韩国",
    genres: ["悬疑", "惊悚"],
    director: "崔民秀",
    cast: ["韩志勋", "朴恩静"],
    rating: 8.2,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20Korean%20thriller%20poster%2C%20a%20lone%20witness%20silhouette%20behind%20frosted%20glass%20in%20a%20dim%20interrogation%20room%2C%20cold%20muted%20shadows%20with%20a%20single%20warm%20accent%20light%2C%20tense%20minimal%20composition%2C%20high%20detail%20film%20key%20art&width=600&height=900&seq=md-mv-11&orientation=portrait",
    summary: "唯一的目击者是一位无法开口的哑女，检察官必须在她沉默的证词中拼凑出真相。",
    status: "HD中字",
    hot: 7320,
    updatedAt: "2024-07-08",
    tags: ["犯罪", "反转", "紧张"],
  },
  {
    id: "movie-12",
    title: "荒漠骑士",
    type: "movie",
    year: 2022,
    region: "美国",
    genres: ["西部", "动作"],
    director: "杰克·哈里斯",
    cast: ["汤姆·雷德", "安娜·贝尔"],
    rating: 7.8,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20western%20action%20poster%2C%20a%20lone%20cowboy%20on%20horseback%20crossing%20a%20vast%20desert%20at%20sunset%2C%20long%20shadows%20and%20dust%2C%20warm%20amber%20sky%20against%20deep%20earth%20tones%2C%20minimal%20epic%20composition%2C%20high%20detail%20film%20key%20art&width=600&height=900&seq=md-mv-12&orientation=portrait",
    summary: "一个沉默的赏金猎人为了赎罪，护送一位神秘的陌生人穿越危机四伏的荒漠。",
    status: "HD中字",
    hot: 6120,
    updatedAt: "2024-03-22",
    tags: ["西部", "复仇", "孤独"],
  },
  {
    id: "movie-13",
    title: "云端之上",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "励志"],
    director: "何晓峰",
    cast: ["江雨桐", "程野"],
    rating: 8.6,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20inspirational%20drama%20poster%2C%20a%20young%20pilot%20looking%20up%20at%20the%20sky%20through%20an%20aircraft%20cockpit%20window%20at%20dawn%2C%20soft%20amber%20light%20breaking%20through%20deep%20blue%20shadows%2C%20hopeful%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-mv-13&orientation=portrait",
    summary: "出身小镇的女孩怀揣飞行梦想，在一次次跌倒与质疑中，终于飞上了属于自己的云端。",
    status: "蓝光1080P",
    hot: 8880,
    updatedAt: "2024-09-30",
    tags: ["励志", "梦想", "成长"],
  },
  {
    id: "movie-14",
    title: "午夜列车",
    type: "movie",
    year: 2023,
    region: "日本",
    genres: ["恐怖", "悬疑"],
    director: "田中裕介",
    cast: ["小林亮", "松本奈"],
    rating: 7.6,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20horror%20mystery%20poster%2C%20an%20empty%20dimly%20lit%20subway%20carriage%20at%20midnight%20with%20flickering%20lights%20and%20a%20distant%20figure%2C%20eerie%20cold%20shadows%20with%20a%20faint%20warm%20glow%2C%20unsettling%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-mv-14&orientation=portrait",
    summary: "一趟只在午夜发车的列车，载着一群各怀秘密的乘客，驶向无法回头的终点。",
    status: "HD中字",
    hot: 5980,
    updatedAt: "2024-06-30",
    tags: ["惊悚", "密闭空间", "烧脑"],
  },
  {
    id: "movie-15",
    title: "笑闹江湖",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "武侠"],
    director: "马天行",
    cast: ["郭子轩", "宋佳宁"],
    rating: 7.4,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20comedy%20wuxia%20movie%20poster%2C%20a%20goofy%20young%20martial%20artist%20striking%20a%20dramatic%20pose%20in%20a%20misty%20bamboo%20forest%2C%20playful%20warm%20amber%20light%20against%20deep%20green%20shadows%2C%20lively%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-mv-15&orientation=portrait",
    summary: "一个只想开饭馆的倒霉少侠，阴差阳错卷入了武林盟主之争，笑料百出。",
    status: "HD中字",
    hot: 7040,
    updatedAt: "2024-08-25",
    tags: ["爆笑", "武侠", "下饭"],
  },
  {
    id: "movie-16",
    title: "光年密码",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["科幻", "悬疑"],
    director: "布莱恩·沃克",
    cast: ["丹尼尔·福斯特", "克莱尔·亚当斯"],
    rating: 8.0,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20sci-fi%20mystery%20poster%2C%20a%20scientist%20before%20a%20giant%20glowing%20cipher%20hologram%20in%20a%20dark%20laboratory%2C%20amber%20and%20cyan%20accents%20against%20deep%20black%20shadows%2C%20intellectual%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-mv-16&orientation=portrait",
    summary: "一段来自亿万光年外的神秘信号，让一位语言学家踏上了解码宇宙真相的旅程。",
    status: "HD中字",
    hot: 7760,
    updatedAt: "2024-07-18",
    tags: ["硬科幻", "烧脑", "宇宙"],
  },
  {
    id: "movie-17",
    title: "曼谷往事",
    type: "movie",
    year: 2022,
    region: "泰国",
    genres: ["剧情", "爱情"],
    director: "阿南·辛哈",
    cast: ["塔纳蓬", "娜帕"],
    rating: 7.7,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20romantic%20drama%20poster%2C%20a%20couple%20standing%20on%20an%20old%20Bangkok%20canal%20bridge%20at%20dusk%2C%20warm%20amber%20street%20lamps%20against%20deep%20tropical%20shadows%2C%20nostalgic%20soft%20mood%2C%20minimal%20elegant%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-mv-17&orientation=portrait",
    summary: "多年以后重返曼谷的她，在熟悉的街角重新遇见了那段没能说出口的青春往事。",
    status: "HD中字",
    hot: 5640,
    updatedAt: "2024-02-14",
    tags: ["文艺", "遗憾", "热带"],
  },
  {
    id: "movie-18",
    title: "雪岭孤鹰",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["冒险", "动作"],
    director: "高远",
    cast: ["秦锋", "白露"],
    rating: 8.4,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20adventure%20action%20poster%2C%20a%20climber%20ascending%20a%20snowy%20mountain%20ridge%20in%20a%20blizzard%2C%20warm%20amber%20headlamp%20against%20deep%20cold%20blue%20shadows%2C%20dramatic%20epic%20minimal%20composition%2C%20high%20detail%20film%20key%20art&width=600&height=900&seq=md-mv-18&orientation=portrait",
    summary: "为寻找失踪的登山队，一名救援专家独自挑战从未有人登顶的雪岭，直面自然与内心的双重绝境。",
    status: "蓝光1080P",
    hot: 8620,
    updatedAt: "2024-09-15",
    tags: ["极限", "生存", "雪山"],
  },

  // ================= 电视剧 =================
  {
    id: "tv-01",
    title: "长夜将明",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "刑侦"],
    director: "徐怀山",
    cast: ["陆知远", "苏念"],
    rating: 8.9,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20crime%20drama%20series%20poster%2C%20a%20detective%20silhouette%20before%20a%20lone%20street%20lamp%20in%20a%20dark%20rainy%20city%20at%20night%2C%20warm%20orange%20light%20against%20deep%20shadows%2C%20tense%20minimal%20composition%2C%20high%20detail%20film%20key%20art&width=600&height=900&seq=md-tv-01&orientation=portrait",
    summary: "连环悬案横跨二十年，两代刑警接力追凶，在漫长的黑夜里坚守到黎明的到来。",
    status: "更新至18集",
    hot: 9540,
    updatedAt: "2024-10-08",
    tags: ["追凶", "群像", "高分剧"],
  },
  {
    id: "tv-02",
    title: "冰与火之痕",
    type: "tv",
    year: 2023,
    region: "美国",
    genres: ["奇幻", "史诗"],
    director: "大卫·斯通",
    cast: ["瑞恩·凯尔", "艾拉·莫里斯"],
    rating: 8.5,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20epic%20fantasy%20series%20poster%2C%20a%20cloaked%20warrior%20holding%20a%20glowing%20sword%20before%20a%20vast%20candle-lit%20stone%20throne%20hall%2C%20warm%20firelight%20against%20deep%20cold%20shadows%2C%20epic%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-02&orientation=portrait",
    summary: "七个王国因王位空虚而燃起战火，龙之血脉与冰原异族同时苏醒，大陆命运悬于一线。",
    status: "全10集",
    hot: 8120,
    updatedAt: "2024-06-12",
    tags: ["权谋", "史诗", "烧脑"],
  },
  {
    id: "tv-03",
    title: "首尔恋歌",
    type: "tv",
    year: 2024,
    region: "韩国",
    genres: ["爱情", "都市"],
    director: "金智勋",
    cast: ["崔宇彬", "李书妍"],
    rating: 8.3,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20Korean%20romance%20series%20poster%2C%20a%20couple%20standing%20on%20a%20Seoul%20rooftop%20at%20night%20under%20city%20lights%2C%20warm%20amber%20bokeh%20against%20deep%20muted%20shadows%2C%20romantic%20soft%20mood%2C%20minimal%20elegant%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-03&orientation=portrait",
    summary: "一位冷面建筑师与一位开朗咖啡师在首尔的街头相遇，两个受伤的灵魂慢慢靠近彼此。",
    status: "更新至12集",
    hot: 8460,
    updatedAt: "2024-09-25",
    tags: ["甜宠", "治愈", "都市"],
  },
  {
    id: "tv-04",
    title: "星尘纪年",
    type: "tv",
    year: 2023,
    region: "美国",
    genres: ["科幻", "太空"],
    director: "尼古拉斯·佩里",
    cast: ["亚当·里维斯", "佐伊·汉森"],
    rating: 8.7,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20sci-fi%20space%20series%20poster%2C%20a%20space%20station%20crew%20before%20a%20glowing%20star%20map%20hologram%20with%20a%20distant%20planet%20outside%20the%20window%2C%20warm%20amber%20accents%20against%20deep%20black%20shadows%2C%20minimal%20cinematic%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-04&orientation=portrait",
    summary: "殖民舰队在穿越星尘带时遭遇未知文明，船员们必须在生存与道义之间做出抉择。",
    status: "全8集",
    hot: 7890,
    updatedAt: "2024-05-30",
    tags: ["太空歌剧", "群像", "视效"],
  },
  {
    id: "tv-05",
    title: "京华烟云录",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "家族"],
    director: "沈清",
    cast: ["温岚", "纪云舒"],
    rating: 8.6,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20Chinese%20period%20family%20drama%20series%20poster%2C%20an%20elegant%20noblewoman%20in%20ornate%20Hanfu%20standing%20in%20a%20candle-lit%20traditional%20mansion%20hall%2C%20warm%20amber%20lantern%20glow%20against%20deep%20shadows%2C%20minimal%20elegant%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-05&orientation=portrait",
    summary: "民国初年，京华望族的兴衰浮沉中，一位坚韧的女子撑起整个家族，也守护住了心中的道义。",
    status: "更新至24集",
    hot: 9180,
    updatedAt: "2024-10-06",
    tags: ["民国", "家族", "大女主"],
  },
  {
    id: "tv-06",
    title: "东京迷案簿",
    type: "tv",
    year: 2023,
    region: "日本",
    genres: ["悬疑", "刑侦"],
    director: "中村和彦",
    cast: ["高桥彻", "长谷川绫"],
    rating: 8.4,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20Japanese%20detective%20series%20poster%2C%20a%20detective%20examining%20a%20case%20file%20under%20a%20single%20desk%20lamp%20in%20a%20dark%20office%2C%20warm%20amber%20light%20against%20deep%20shadows%2C%20tense%20minimal%20composition%2C%20high%20detail%20film%20key%20art&width=600&height=900&seq=md-tv-06&orientation=portrait",
    summary: "一册泛黄的旧案簿牵出连环谜案，警视厅的怪才侦探与法医搭档联手追查真相。",
    status: "全9集",
    hot: 7640,
    updatedAt: "2024-07-22",
    tags: ["本格推理", "搭档", "暗黑"],
  },
  {
    id: "tv-07",
    title: "医者仁心",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "职场"],
    director: "林海",
    cast: ["周明远", "夏思雨"],
    rating: 8.8,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20medical%20drama%20series%20poster%2C%20a%20surgeon%20in%20scrubs%20standing%20in%20a%20dim%20hospital%20corridor%20at%20night%2C%20warm%20amber%20light%20from%20a%20doorway%20against%20deep%20shadows%2C%20hopeful%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-07&orientation=portrait",
    summary: "急诊科的一线医生们与死神赛跑，在一次次生死抉择中诠释医者的责任与温度。",
    status: "更新至20集",
    hot: 8760,
    updatedAt: "2024-09-28",
    tags: ["医疗", "群像", "正能量"],
  },
  {
    id: "tv-08",
    title: "硅谷风云",
    type: "tv",
    year: 2022,
    region: "美国",
    genres: ["剧情", "商战"],
    director: "迈克尔·陈",
    cast: ["埃里克·李", "娜塔莉·王"],
    rating: 8.6,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20startup%20business%20drama%20series%20poster%2C%20young%20entrepreneurs%20before%20a%20glowing%20data%20wall%20in%20a%20dark%20modern%20office%2C%20warm%20amber%20accents%20against%20deep%20cool%20shadows%2C%20sharp%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-08&orientation=portrait",
    summary: "一间车库创业公司如何在资本风暴中逆袭崛起，又如何在欲望与初心之间摇摆。",
    status: "全10集",
    hot: 6980,
    updatedAt: "2024-04-18",
    tags: ["创业", "商战", "现实"],
  },
  {
    id: "tv-09",
    title: "樱花约定",
    type: "tv",
    year: 2024,
    region: "日本",
    genres: ["爱情", "青春"],
    director: "井上淳",
    cast: ["佐藤悠真", "小林咲"],
    rating: 8.1,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20Japanese%20youth%20romance%20series%20poster%2C%20a%20boy%20and%20girl%20standing%20under%20blooming%20cherry%20trees%20at%20dusk%2C%20warm%20amber%20light%20against%20deep%20muted%20shadows%2C%20nostalgic%20soft%20mood%2C%20minimal%20elegant%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-09&orientation=portrait",
    summary: "高三那年的樱花树下，他们许下一个约定，多年后重逢时，是否还能找回当初的心动。",
    status: "更新至10集",
    hot: 8020,
    updatedAt: "2024-09-12",
    tags: ["青春", "初恋", "治愈"],
  },
  {
    id: "tv-10",
    title: "破晓行动",
    type: "tv",
    year: 2023,
    region: "中国大陆",
    genres: ["谍战", "悬疑"],
    director: "顾长山",
    cast: ["韩铮", "叶清秋"],
    rating: 8.7,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20spy%20thriller%20series%20poster%2C%20a%20man%20in%20a%20fedora%20and%20long%20coat%20standing%20in%20a%20rainy%20old%20city%20street%20at%20night%2C%20warm%20orange%20lamplight%20against%20deep%20shadows%2C%20tense%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-10&orientation=portrait",
    summary: "黎明前最黑暗的时刻，潜伏在敌人内部的无名英雄，用生命传递出关键情报。",
    status: "全32集",
    hot: 8940,
    updatedAt: "2024-08-05",
    tags: ["谍战", "烧脑", "信仰"],
  },
  {
    id: "tv-11",
    title: "王冠之影",
    type: "tv",
    year: 2023,
    region: "英国",
    genres: ["历史", "宫廷"],
    director: "爱德华·摩尔",
    cast: ["威廉·哈特", "凯瑟琳·福特"],
    rating: 8.9,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20British%20royal%20period%20drama%20series%20poster%2C%20a%20regal%20figure%20in%20rich%20robes%20standing%20in%20a%20vast%20candle-lit%20palace%20hall%20of%20stone%20arches%2C%20warm%20amber%20candlelight%20against%20deep%20shadows%2C%20minimal%20elegant%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-11&orientation=portrait",
    summary: "王座之下暗流涌动，一位年轻的君主在权臣与家族之间周旋，守护摇摇欲坠的帝国。",
    status: "全8集",
    hot: 7420,
    updatedAt: "2024-06-20",
    tags: ["宫廷", "权谋", "质感"],
  },
  {
    id: "tv-12",
    title: "心动的信号站",
    type: "tv",
    year: 2024,
    region: "韩国",
    genres: ["爱情", "喜剧"],
    director: "朴成勋",
    cast: ["郑浩俊", "徐雅琳"],
    rating: 7.9,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20romantic%20comedy%20series%20poster%2C%20a%20cheerful%20couple%20sharing%20earphones%20on%20a%20city%20subway%20platform%20at%20night%2C%20warm%20amber%20lights%20against%20deep%20shadows%2C%20playful%20soft%20mood%2C%20minimal%20elegant%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-12&orientation=portrait",
    summary: "一档深夜电台节目意外撮合了两个毫不相干的人，一场甜到冒泡的错位恋爱就此展开。",
    status: "更新至14集",
    hot: 8280,
    updatedAt: "2024-09-18",
    tags: ["甜宠", "下饭", "轻喜"],
  },
  {
    id: "tv-13",
    title: "代码之外",
    type: "tv",
    year: 2023,
    region: "美国",
    genres: ["科幻", "惊悚"],
    director: "亚历克斯·诺兰",
    cast: ["卢卡斯·梅耶", "格蕾丝·李"],
    rating: 8.5,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20tech%20thriller%20series%20poster%2C%20a%20programmer%20before%20a%20wall%20of%20glowing%20code%20in%20a%20dark%20server%20room%2C%20warm%20amber%20accents%20against%20deep%20black%20shadows%2C%20tense%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-13&orientation=portrait",
    summary: "一位天才程序员发现公司的人工智能藏着不可告人的秘密，越接近真相，危险越逼近。",
    status: "全10集",
    hot: 7180,
    updatedAt: "2024-05-12",
    tags: ["AI", "科技伦理", "紧张"],
  },
  {
    id: "tv-14",
    title: "大唐神探录",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["古装", "悬疑"],
    director: "韦青云",
    cast: ["裴云卿", "花月棠"],
    rating: 8.6,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20ancient%20Chinese%20detective%20series%20poster%2C%20a%20scholar%20detective%20holding%20a%20lantern%20in%20a%20misty%20Tang%20dynasty%20night%20street%2C%20warm%20amber%20lantern%20glow%20against%20deep%20shadows%2C%20mysterious%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-14&orientation=portrait",
    summary: "大唐盛世之下暗藏奇案，一位落第书生凭借过人智慧，与女捕快联手破解迷局。",
    status: "更新至26集",
    hot: 9460,
    updatedAt: "2024-10-02",
    tags: ["探案", "古装", "单元剧"],
  },
  {
    id: "tv-15",
    title: "曼哈顿公寓",
    type: "tv",
    year: 2022,
    region: "美国",
    genres: ["喜剧", "情景"],
    director: "史蒂夫·罗曼",
    cast: ["杰克·布朗", "艾玛·怀特"],
    rating: 8.2,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20sitcom%20series%20poster%2C%20a%20group%20of%20roommates%20laughing%20together%20in%20a%20cozy%20New%20York%20apartment%20at%20night%2C%20warm%20amber%20lamp%20glow%20against%20deep%20shadows%2C%20cheerful%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-15&orientation=portrait",
    summary: "六个性格迥异的年轻人挤在纽约的一间小公寓里，每天都在上演鸡飞狗跳的欢乐日常。",
    status: "全12集",
    hot: 6540,
    updatedAt: "2024-03-08",
    tags: ["情景喜剧", "解压", "友情"],
  },
  {
    id: "tv-16",
    title: "逆风翻盘",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["体育", "励志"],
    director: "赵岩",
    cast: ["陈锐", "林小满"],
    rating: 8.3,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20sports%20drama%20series%20poster%2C%20a%20determined%20young%20athlete%20standing%20alone%20on%20a%20floodlit%20stadium%20field%20at%20night%2C%20warm%20amber%20stadium%20lights%20against%20deep%20shadows%2C%20inspiring%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-16&orientation=portrait",
    summary: "被球队放弃的天才少年，从低谷重新出发，带领一支杂牌军向着冠军发起不可能冲击。",
    status: "更新至16集",
    hot: 8360,
    updatedAt: "2024-09-22",
    tags: ["热血", "体育", "青春"],
  },
  {
    id: "tv-17",
    title: "柏林迷雾",
    type: "tv",
    year: 2023,
    region: "德国",
    genres: ["悬疑", "惊悚"],
    director: "汉斯·穆勒",
    cast: ["弗里德里希·朗", "安娜·施密特"],
    rating: 8.4,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20German%20thriller%20series%20poster%2C%20a%20lone%20figure%20walking%20through%20a%20foggy%20concrete%20Berlin%20street%20at%20night%2C%20warm%20amber%20lamplight%20against%20deep%20cold%20shadows%2C%20moody%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-17&orientation=portrait",
    summary: "一名记者追查一桩跨国洗钱案，却在柏林的重重迷雾中发现自己的过去也被卷入其中。",
    status: "全8集",
    hot: 6880,
    updatedAt: "2024-07-15",
    tags: ["欧洲", "阴谋", "暗黑"],
  },
  {
    id: "tv-18",
    title: "情迷普罗旺斯",
    type: "tv",
    year: 2022,
    region: "法国",
    genres: ["爱情", "剧情"],
    director: "让·杜邦",
    cast: ["路易·加西亚", "玛丽·罗兰"],
    rating: 7.8,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20romantic%20drama%20series%20poster%2C%20a%20woman%20standing%20in%20a%20lavender%20field%20in%20Provence%20at%20dusk%2C%20warm%20amber%20sunset%20light%20against%20deep%20purple%20shadows%2C%20elegant%20soft%20mood%2C%20minimal%20composition%2C%20film%20key%20art&width=600&height=900&seq=md-tv-18&orientation=portrait",
    summary: "一位失意的厨师远赴普罗旺斯小镇，在薰衣草与橄榄树之间，重新找回了生活的味道。",
    status: "全10集",
    hot: 5760,
    updatedAt: "2024-02-28",
    tags: ["治愈", "法式浪漫", "田园"],
  },

  // ================= 综艺 =================
  {
    id: "variety-01",
    title: "星光大冒险",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["真人秀", "户外"],
    director: "节目组",
    cast: ["嘉宾阵容", "当红艺人"],
    rating: 8.2,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20variety%20show%20poster%2C%20a%20team%20of%20energetic%20young%20people%20adventuring%20through%20a%20mountain%20camp%20at%20dusk%20with%20string%20lights%2C%20warm%20amber%20glow%20against%20deep%20shadows%2C%20playful%20vibrant%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-01&orientation=portrait",
    summary: "明星嘉宾们组成冒险小队，深入祖国大好河山完成各种爆笑又热血的户外挑战。",
    status: "更新至第8期",
    hot: 8560,
    updatedAt: "2024-10-10",
    tags: ["户外", "真人秀", "团综"],
  },
  {
    id: "variety-02",
    title: "美食奇遇记",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["美食", "旅行"],
    director: "节目组",
    cast: ["美食嘉宾"],
    rating: 8.5,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20food%20travel%20variety%20poster%2C%20a%20steaming%20traditional%20Chinese%20banquet%20table%20at%20night%20with%20warm%20lanterns%2C%20appetizing%20warm%20amber%20lighting%20against%20deep%20shadows%2C%20cozy%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-02&orientation=portrait",
    summary: "跟着美食家走街串巷，从街头小吃到非遗名菜，在一城一味中寻找人间的烟火气。",
    status: "更新至第12期",
    hot: 8820,
    updatedAt: "2024-10-05",
    tags: ["下饭", "美食", "治愈"],
  },
  {
    id: "variety-03",
    title: "音乐无限赛",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["音乐", "竞技"],
    director: "节目组",
    cast: ["实力歌手"],
    rating: 8.7,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20music%20competition%20variety%20poster%2C%20a%20singer%20performing%20on%20a%20dramatic%20concert%20stage%20under%20a%20single%20spotlight%2C%20warm%20amber%20stage%20light%20against%20deep%20black%20shadows%2C%20energetic%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-03&orientation=portrait",
    summary: "华语实力唱将同台竞演，用最真挚的歌声征服全场，每一期都是一场听觉盛宴。",
    status: "全12期",
    hot: 7940,
    updatedAt: "2024-06-28",
    tags: ["音乐", "竞演", "live"],
  },
  {
    id: "variety-04",
    title: "极限挑战营",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["竞技", "真人秀"],
    director: "节目组",
    cast: ["常驻嘉宾"],
    rating: 8.3,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20extreme%20sports%20variety%20poster%2C%20contestants%20crossing%20a%20suspended%20rope%20bridge%20in%20a%20dramatic%20canyon%20at%20sunrise%2C%20warm%20amber%20light%20against%20deep%20shadows%2C%20thrilling%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-04&orientation=portrait",
    summary: "极限运动员与明星嘉宾组队闯关，在真实极限环境中挑战体能与意志的边界。",
    status: "更新至第10期",
    hot: 8620,
    updatedAt: "2024-09-30",
    tags: ["竞技", "热血", "闯关"],
  },
  {
    id: "variety-05",
    title: "脱口秀之夜",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["脱口秀", "喜剧"],
    director: "节目组",
    cast: ["脱口秀演员"],
    rating: 8.6,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20stand-up%20comedy%20variety%20poster%2C%20a%20comedian%20holding%20a%20microphone%20on%20a%20brick-wall%20club%20stage%20under%20a%20warm%20spotlight%2C%20deep%20shadows%20with%20amber%20glow%2C%20playful%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-05&orientation=portrait",
    summary: "一群最会讲段子的人聚在一起，用幽默解构生活，每一句都戳中你的笑点与泪点。",
    status: "更新至第9期",
    hot: 9040,
    updatedAt: "2024-10-08",
    tags: ["爆笑", "语言艺术", "解压"],
  },
  {
    id: "variety-06",
    title: "环球旅行家",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["旅行", "纪实"],
    director: "节目组",
    cast: ["旅行达人"],
    rating: 8.1,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20travel%20documentary%20variety%20poster%2C%20a%20traveler%20with%20a%20backpack%20on%20a%20cliff%20overlooking%20a%20vast%20dramatic%20landscape%20at%20dusk%2C%20warm%20amber%20light%20against%20deep%20shadows%2C%20epic%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-06&orientation=portrait",
    summary: "跟随旅行家的脚步环游世界，记录不同土地上人们真实的生活与最动人的风景。",
    status: "全10期",
    hot: 7020,
    updatedAt: "2024-05-16",
    tags: ["旅行", "人文", "风光"],
  },
  {
    id: "variety-07",
    title: "我是演员了",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["表演", "竞技"],
    director: "节目组",
    cast: ["青年演员"],
    rating: 8.0,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20acting%20competition%20variety%20poster%2C%20an%20actor%20performing%20a%20dramatic%20scene%20on%20a%20theatrical%20stage%20under%20a%20single%20amber%20spotlight%2C%20deep%20shadows%2C%20intense%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-07&orientation=portrait",
    summary: "青年演员同台飙戏，用一段段真实动人的表演，接受观众与导师的双重检验。",
    status: "更新至第7期",
    hot: 8380,
    updatedAt: "2024-09-26",
    tags: ["演技", "竞演", "催泪"],
  },
  {
    id: "variety-08",
    title: "街舞风暴",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["舞蹈", "竞技"],
    director: "节目组",
    cast: ["街舞舞者"],
    rating: 8.4,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20street%20dance%20competition%20poster%2C%20a%20dancer%20freezing%20in%20a%20powerful%20move%20on%20a%20dark%20stage%20with%20amber%20light%20streaks%2C%20deep%20shadows%2C%20dynamic%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-08&orientation=portrait",
    summary: "来自全国各地的顶尖舞者齐聚舞台，用最炸裂的舞步点燃整个夏天。",
    status: "全14期",
    hot: 7760,
    updatedAt: "2024-07-04",
    tags: ["街舞", "热血", "炸场"],
  },
  {
    id: "variety-09",
    title: "亲子时光机",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["亲子", "生活"],
    director: "节目组",
    cast: ["明星家庭"],
    rating: 8.2,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20family%20reality%20variety%20poster%2C%20parents%20and%20children%20baking%20together%20in%20a%20cozy%20warm-lit%20kitchen%20at%20night%2C%20amber%20glow%20against%20deep%20shadows%2C%20heartwarming%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-09&orientation=portrait",
    summary: "明星父母带着孩子穿越回童年，用最朴素的陪伴，找回亲子之间久违的温暖。",
    status: "更新至第11期",
    hot: 8120,
    updatedAt: "2024-10-01",
    tags: ["亲子", "治愈", "温馨"],
  },
  {
    id: "variety-10",
    title: "密室逃脱王",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "游戏"],
    director: "节目组",
    cast: ["常驻玩家"],
    rating: 8.5,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20escape%20room%20variety%20poster%2C%20players%20with%20flashlights%20exploring%20a%20dim%20abandoned%20mansion%20corridor%2C%20warm%20amber%20torch%20light%20against%20deep%20eerie%20shadows%2C%20tense%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-10&orientation=portrait",
    summary: "烧脑密室一个接一个，明星玩家在紧张刺激的解谜中上演高能名场面。",
    status: "更新至第8期",
    hot: 8580,
    updatedAt: "2024-09-28",
    tags: ["烧脑", "密室", "高能"],
  },
  {
    id: "variety-11",
    title: "音乐节现场",
    type: "variety",
    year: 2023,
    region: "韩国",
    genres: ["音乐", "舞台"],
    director: "节目组",
    cast: ["人气歌手"],
    rating: 8.6,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20music%20festival%20variety%20poster%2C%20a%20crowd%20with%20raised%20hands%20before%20a%20massive%20glowing%20outdoor%20stage%20at%20night%2C%20warm%20amber%20light%20beams%20against%20deep%20black%20shadows%2C%20energetic%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-11&orientation=portrait",
    summary: "记录一场万人音乐节的台前幕后，从彩排到高潮，感受音乐现场最纯粹的力量。",
    status: "全10期",
    hot: 7280,
    updatedAt: "2024-06-08",
    tags: ["音乐节", "现场", "氛围"],
  },
  {
    id: "variety-12",
    title: "厨房大师赛",
    type: "variety",
    year: 2024,
    region: "美国",
    genres: ["美食", "竞技"],
    director: "节目组",
    cast: ["名厨评委"],
    rating: 8.3,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20cooking%20competition%20variety%20poster%2C%20chefs%20plating%20dishes%20on%20a%20professional%20restaurant%20kitchen%20counter%20under%20warm%20spotlights%2C%20amber%20glow%20against%20deep%20shadows%2C%20focused%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-12&orientation=portrait",
    summary: "来自世界各地的厨师同台竞技，在有限时间内用一道菜决出厨艺之王的归属。",
    status: "更新至第9期",
    hot: 8260,
    updatedAt: "2024-09-20",
    tags: ["美食", "竞技", "下饭"],
  },
  {
    id: "variety-13",
    title: "恋爱观察室",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["恋爱", "真人秀"],
    director: "节目组",
    cast: ["观察嘉宾"],
    rating: 7.9,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20dating%20reality%20variety%20poster%2C%20young%20men%20and%20women%20meeting%20in%20a%20warm-lit%20rooftop%20lounge%20at%20night%20with%20city%20lights%2C%20amber%20glow%20against%20deep%20shadows%2C%20romantic%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-13&orientation=portrait",
    summary: "素人男女在同住生活中寻找心动，明星观察团全程围观，解读每一次微妙的情感信号。",
    status: "更新至第12期",
    hot: 8480,
    updatedAt: "2024-10-03",
    tags: ["恋爱", "观察", "甜"],
  },
  {
    id: "variety-14",
    title: "荒野求生记",
    type: "variety",
    year: 2023,
    region: "英国",
    genres: ["生存", "纪实"],
    director: "节目组",
    cast: ["生存专家"],
    rating: 8.7,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20wilderness%20survival%20documentary%20poster%2C%20a%20survivalist%20building%20a%20campfire%20in%20a%20dense%20dark%20forest%20at%20dusk%2C%20warm%20amber%20firelight%20against%20deep%20green%20shadows%2C%20raw%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-14&orientation=portrait",
    summary: "跟随生存专家深入无人荒野，仅靠一把小刀与双手，在极限环境中寻找生路。",
    status: "全8期",
    hot: 6940,
    updatedAt: "2024-05-24",
    tags: ["荒野", "硬核", "纪实"],
  },
  {
    id: "variety-15",
    title: "喜剧大联盟",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["喜剧", "竞技"],
    director: "节目组",
    cast: ["喜剧团队"],
    rating: 8.4,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20comedy%20sketch%20variety%20poster%2C%20a%20group%20of%20comedians%20in%20silly%20costumes%20performing%20on%20a%20warm-lit%20stage%2C%20amber%20spotlight%20against%20deep%20shadows%2C%20playful%20vibrant%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-15&orientation=portrait",
    summary: "多支喜剧团队同台比拼，用脑洞大开的喜剧作品，陪你笑到停不下来。",
    status: "更新至第10期",
    hot: 8740,
    updatedAt: "2024-09-24",
    tags: ["喜剧", "小品", "爆笑"],
  },
  {
    id: "variety-16",
    title: "时尚新势力",
    type: "variety",
    year: 2023,
    region: "美国",
    genres: ["时尚", "竞技"],
    director: "节目组",
    cast: ["设计师选手"],
    rating: 8.0,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20fashion%20design%20competition%20variety%20poster%2C%20models%20walking%20a%20glowing%20runway%20at%20night%20with%20amber%20light%20beams%2C%20deep%20shadows%2C%20elegant%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-16&orientation=portrait",
    summary: "新锐设计师在聚光灯下同台竞技，用一件件惊艳作品，定义时尚的下一个风向。",
    status: "全12期",
    hot: 6720,
    updatedAt: "2024-04-30",
    tags: ["时尚", "设计", "高级感"],
  },
  {
    id: "variety-17",
    title: "唱作新声",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["音乐", "原创"],
    director: "节目组",
    cast: ["唱作歌手"],
    rating: 8.5,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20singer-songwriter%20variety%20poster%2C%20a%20musician%20playing%20an%20acoustic%20guitar%20in%20a%20warm-lit%20intimate%20studio%20at%20night%2C%20amber%20glow%20against%20deep%20shadows%2C%20emotional%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-17&orientation=portrait",
    summary: "聚焦原创唱作人，每一首全新作品都讲述一段真实故事，用歌声打动人心的力量。",
    status: "更新至第8期",
    hot: 8920,
    updatedAt: "2024-10-06",
    tags: ["原创", "音乐", "走心"],
  },
  {
    id: "variety-18",
    title: "奔跑吧少年",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["竞技", "户外"],
    director: "节目组",
    cast: ["少年嘉宾"],
    rating: 8.1,
    poster: "https://readdy.ai/api/search-image?query=Dark%20cinematic%20outdoor%20team%20game%20variety%20poster%2C%20energetic%20teenagers%20running%20through%20a%20city%20park%20at%20dusk%20in%20a%20fun%20race%2C%20warm%20amber%20light%20against%20deep%20shadows%2C%20dynamic%20minimal%20composition%2C%20key%20art&width=600&height=900&seq=md-va-18&orientation=portrait",
    summary: "一群元气少年组队完成城市任务赛，在奔跑与协作中收获成长与友谊。",
    status: "全12期",
    hot: 7600,
    updatedAt: "2024-06-02",
    tags: ["青春", "户外", "竞技"],
  },
];

export const heroIds = [
  "movie-06",
  "tv-01",
  "movie-01",
  "tv-14",
  "movie-10",
  "variety-05",
];

export const heroBackdrops = [
  "https://readdy.ai/api/search-image?query=Epic%20dark%20cinematic%20fantasy%20backdrop%2C%20floating%20mythical%20mountains%20with%20glowing%20amber%20clouds%20and%20a%20lone%20hero%20silhouette%2C%20deep%20moody%20shadows%2C%20dramatic%20atmospheric%20lighting%2C%20wide%20minimal%20film%20key%20art%20composition&width=1920&height=1080&seq=md-hero-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Epic%20dark%20cinematic%20crime%20drama%20backdrop%2C%20rain-soaked%20night%20city%20street%20with%20neon%20reflections%20and%20a%20lone%20detective%20silhouette%2C%20warm%20orange%20rim%20light%2C%20deep%20shadows%2C%20moody%20wide%20film%20key%20art%20composition&width=1920&height=1080&seq=md-hero-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Epic%20dark%20cinematic%20suspense%20thriller%20backdrop%2C%20a%20silhouette%20in%20a%20foggy%20dim%20alley%20with%20a%20single%20warm%20street%20lamp%2C%20deep%20low-key%20shadows%2C%20mysterious%20atmospheric%20lighting%2C%20wide%20minimal%20film%20key%20art%20composition&width=1920&height=1080&seq=md-hero-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Epic%20dark%20cinematic%20ancient%20Chinese%20detective%20backdrop%2C%20misty%20Tang%20dynasty%20night%20street%20with%20glowing%20lanterns%20and%20a%20scholar%20silhouette%2C%20warm%20amber%20lantern%20glow%20against%20deep%20shadows%2C%20wide%20film%20key%20art%20composition&width=1920&height=1080&seq=md-hero-04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Epic%20dark%20cinematic%20crime%20noir%20backdrop%2C%20narrow%20neon-lit%20Hong%20Kong%20street%20at%20night%20with%20wet%20reflections%20and%20a%20lone%20figure%2C%20warm%20orange%20neon%20against%20deep%20shadows%2C%20wide%20moody%20film%20key%20art%20composition&width=1920&height=1080&seq=md-hero-05&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Epic%20dark%20cinematic%20comedy%20show%20backdrop%2C%20a%20warm-lit%20brick-wall%20club%20stage%20with%20a%20single%20spotlight%20and%20a%20microphone%20stand%2C%20amber%20glow%20against%20deep%20shadows%2C%20wide%20minimal%20film%20key%20art%20composition&width=1920&height=1080&seq=md-hero-06&orientation=landscape",
];